import { render, staticRenderFns } from "./BreakdownPage.vue?vue&type=template&id=19603d12&"
import script from "./BreakdownPage.vue?vue&type=script&lang=js&"
export * from "./BreakdownPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports